// One-shot hand-over of a sign-in failure to the login page. A failed app
// init logs the user out (which clears localStorage and Redux) before the
// route guards land on /login, so the reason is parked in sessionStorage,
// which the logout leaves alone. The login page reads it once on mount.
const PENDING_LOGIN_ERROR_KEY = 'adup_pending_login_error';

export function setPendingLoginError(message: string): void {
  try {
    window.sessionStorage.setItem(PENDING_LOGIN_ERROR_KEY, message);
  } catch (_e) {
    // storage unavailable: the toast still carries the message
  }
}

/** Returns the pending message (or '') and removes it, so a reload of the
 *  login page doesn't show it again. */
export function consumePendingLoginError(): string {
  try {
    const message = window.sessionStorage.getItem(PENDING_LOGIN_ERROR_KEY);
    window.sessionStorage.removeItem(PENDING_LOGIN_ERROR_KEY);
    return message ?? '';
  } catch (_e) {
    return '';
  }
}
